import approve from 'approvejs';
const SERVER_ERROR = 'server_error';

export function setServerErrors(fields, errors = [], prepareErrorMsgHandler) {
    if (!fields) {
        return;
    }

    visit(fields, (field, prefix) => {
        prefix = prefix ? `${prefix}.${field.name}` : field.name;
        let msg = errors[prefix] ? errors[prefix][0] : '';
        if (prepareErrorMsgHandler) {
            msg = prepareErrorMsgHandler(prefix, msg);
        }
        if (!field.rules[SERVER_ERROR]) {
            field.rules[SERVER_ERROR] = {message: msg}
        } else {
            field.rules[SERVER_ERROR].message = msg;
        }
    });
    return fields;
}

export function removeFieldName(prefix, msg) {
    if (msg) {
        msg = msg.replace(prefix, 'field');
        msg = msg.replace(prefix.replace(new RegExp("_", "gi"), ' '), 'field');
    }
    return msg;
}

const serverErrorTest = {
    expects: ['message'],
    //message: '{message}',
    message: 'Server error',
    validate: (value, pairs) => {
        if (pairs.message) {
            console.log(pairs.message);
        }
        return !pairs.message;
    }
}

function visit(fields, func, prefix) {
    if (prefix === undefined) {
        prefix = '';
    }

    for (const p in fields) {
        if (p) {
            const v = fields[p];
            if (v) {
                if (Array.isArray(v)) {
                    const childPrefix = (prefix ? (prefix + '.' + p) : p) + '.';
                    let idx = 0;
                    for (const item of v) {
                        visit(item, func, childPrefix + idx);
                        idx++;
                    }
                } else if (typeof v === 'object') {
                    if (!v.rules) {
                        v.rules = {};
                    }

                    func(v, prefix);
                }
            }
        } 
    }
}

approve.addTest(serverErrorTest, SERVER_ERROR);


// WEBPACK FOOTER //
// ./src/utils/server_error_rule.js